import { createStore } from 'zustand';

import { Place } from '@/types/google-maps.types';

export type ModalsOpeningState = {
  locationSelectionModalIsOpen: boolean;
  bloquedGeolocationModalIsOpen: boolean;
  signInModalIsOpen: boolean;
  loginCallback?: () => void;
  locationCallback?: (userLocation?: Partial<Place>) => void;
  pendingSearchTerm?: string;
  shouldOpenSearchModal?: boolean;
  shouldScrollToBranchesListOnNavigate?: boolean;
};

export const modalsOpeningStore = createStore<ModalsOpeningState>(() => {
  return {
    locationSelectionModalIsOpen: false,
    bloquedGeolocationModalIsOpen: false,
    signInModalIsOpen: false,
  };
});

export interface SetOpenLocationSelectionModalOptions {
  locationCallback?: (userLocation?: Partial<Place>) => void;
  pendingSearchTerm?: string;
  shouldOpenSearchModal?: boolean;
  shouldScrollToBranchesListOnNavigate?: boolean;
}

export const setOpenLocationSelectionModal = (
  isOpen: boolean,
  options?: SetOpenLocationSelectionModalOptions,
) => {
  modalsOpeningStore.setState((prev) => ({
    locationSelectionModalIsOpen: isOpen,
    locationCallback: isOpen ? options?.locationCallback : undefined,
    pendingSearchTerm: isOpen ? options?.pendingSearchTerm : undefined,
    shouldOpenSearchModal: isOpen ? options?.shouldOpenSearchModal : undefined,
    shouldScrollToBranchesListOnNavigate: isOpen
      ? options?.shouldScrollToBranchesListOnNavigate
      : prev.shouldScrollToBranchesListOnNavigate,
  }));
};

export const setOpenBloquedGeolocationModal = (isOpen: boolean) => {
  modalsOpeningStore.setState({ bloquedGeolocationModalIsOpen: isOpen });
};

export const setOpenSignInModal = (isOpen: boolean, setLoginCallback?: () => void) => {
  modalsOpeningStore.setState({ signInModalIsOpen: isOpen, loginCallback: isOpen ? setLoginCallback : undefined });
};
